import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { HoundNote } from "@/components/HoundNote";

const FAQS = [
  { q: "How do pre-orders work?", a: "Pre-order items are available to reserve and pay for upfront through our secure Shopify checkout. Orders are placed with our supplier once the pre-order window closes, and estimated dispatch times are communicated clearly at checkout and via email." },
  { q: "When will my pre-order be dispatched?", a: "Each pre-order product lists an estimated dispatch window. We'll always keep you updated by email if anything changes, so you're never left wondering." },
  { q: "How do I choose the right size for my dog?", a: "Head to our Size Guide for detailed measurements for both human and hound pieces. If you're between sizes or unsure, get in touch and we'll happily help." },
  { q: "Do you offer matching human and dog sets?", a: "Yes! Our Matching Sets are designed to be worn together, cut from the same cosy fabrics. You'll find them in the Shop under 'Matching Sets'." },
  { q: "What are your fabrics like?", a: "We use soft, premium, considered fabrics chosen for comfort and longevity, cosy knits, brushed cottons and durable canvas. Everything is made to be lived in and loved." },
  { q: "How can I pay?", a: "All orders, including pre-orders, are processed through Shopify's secure checkout, which supports major cards and popular payment methods." },
  { q: "Do you ship internationally?", a: "Shipping options and rates are shown at checkout based on your location. Reach out via our Contact page if you have a specific question." },
  { q: "Can I return or exchange an item?", a: "We want you and your hound to love your pieces. If something isn't right, contact us and we'll walk you through our returns and exchanges process." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
      <div className="text-center mb-12">
        <p className="text-xs uppercase tracking-[0.25em] text-rosegold mb-3">Good to know</p>
        <h1 className="font-display text-4xl sm:text-5xl text-maroon">Frequently Asked Questions</h1>
      </div>
      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-3xl border border-rosegold/15 px-6">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-lg text-inkbrown hover:text-maroon hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-inkbrown/70 leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <HoundNote
        author="Henry"
        message="Didn't find your answer? Head to the Contact page and bark at us. I read every single message — George mostly supervises from the couch."
        className="mx-auto mt-10 rotate-1"
      />
    </div>
  );
}
